/**
 * @file Contributors related mutations.
 */

import gql from 'graphql-tag';

import { AlbumListingDetails } from '../fragments/album';
import { AlbumPhotoGroupBasicDetails } from '../fragments/album-photo-group';

export const contributorAssignmentShareJoin = gql`
  mutation contributorAssignmentShareJoin(
    $input: ContributorAssignmentShareJoinInput!
  ) {
    contributorAssignmentShareJoin(input: $input) {
      contributor_assignment {
        id
      }
    }
  }
`;

export const autoContributorJoin = gql`
  mutation autoContributorJoin($input: AutoContributorJoinInput!) {
    autoContributorJoin(input: $input) {
      success
      contributor_assignment {
        id
        upload_access
        view_access
        dnp_access
        album_create_access
      }
    }
  }
`;

export const albumCreateForContributors = gql`
  mutation albumCreateForContributors($input: AlbumCreateInput!) {
    albumCreate(input: $input) {
      album {
        id
        name
        creator {
          id
        }
        album_photo_groups(slice: { limit: 999 }) {
          total
          records {
            ...AlbumPhotoGroupBasicDetails
          }
        }

        ...AlbumListingDetails
      }
    }
  }
  ${AlbumPhotoGroupBasicDetails}
  ${AlbumListingDetails}
`;

export const albumUpdateForContributors = gql`
  mutation albumUpdateForContributors($input: AlbumUpdateInput!) {
    albumUpdate(input: $input) {
      album {
        id
        name
        creator {
          id
        }
        album_photo_groups(slice: { limit: 999 }) {
          total
          records {
            ...AlbumPhotoGroupBasicDetails
          }
        }

        ...AlbumListingDetails
      }
    }
  }
  ${AlbumPhotoGroupBasicDetails}
  ${AlbumListingDetails}
`;
